// Local.
import { useCosmosEditorial } from 'providers/contexts/CosmosEditorialContext';
import KpiBar from 'components/Dashboard/widgets/KPIs/KpiBar';
import { useSearch } from 'components/Search/SearchContextProvider';

const EditorialSearchKpiBar = () => {
  const { kpibarStateStorageKey } = useSearch();
  const { dashboard } = useCosmosEditorial();

  if (!dashboard) return null;

  return (
    <KpiBar
      storageKey={kpibarStateStorageKey || ''}
      dashboardId={dashboard}
    />
  );
};

export default EditorialSearchKpiBar;
